// Updated: Silence console.log/debug in production to keep the browser console clean.
// console.error and console.warn remain active so real issues stay visible.
if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './app/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
